import { operators } from '@fr/constants';
import Backbone from 'backbone';
import _ from 'underscore';
import { Operator } from '@ve/types';

const prepareTourIdentities = (tours: Backbone.Model[], product: Backbone.Model): string[] => _.chain(tours)
        .groupBy((tourData) => (tourData.get('product') || product).get('operator').id)
        .values()
        .map((operatorTours) => {
            const sortedTours = _.sortBy(operatorTours, (operatorTour) => operatorTour.get('finalPrice'));
            return sortedTours[0].get('id');
        })
        .value();

const prepareTourProductsWithoutHotelAndRailway = (tourProductsGroup: Backbone.Model[], product: Backbone.Model): Backbone.Model[] => _.chain(tourProductsGroup)
        .filter((tourData) => tourData.get('type') === 'TourProduct')
        .groupBy((tourData) => (tourData.get('product') || product).get('operator').id)
        .values()
        .map((operatorTours) => {
            const sortedTours = _.sortBy(operatorTours, (operatorTour) => operatorTour.get('finalPrice'));
            return sortedTours[0];
        })
        .value();

const getCheapestTravelataTourWithTransfer = (tourProductsGroup: Backbone.Model[]): Backbone.Model | null => {
    const travelataTours = tourProductsGroup.filter((tourProduct) => {
        const operator = tourProduct.get('tour')?.get('operator') as Operator;
        return operators.MY_AGENT.includes(operator?.id);
    });
    const travelataToursWithTransfer = travelataTours.filter((tourProduct) => tourProduct.get('transferType') !== 'none');
    const isTravelataToursWithTransferExists = travelataToursWithTransfer.length > 0;
    return isTravelataToursWithTransferExists ? _.sortBy(travelataToursWithTransfer, (tour) => tour.get('price'))[0] : null;
};

const getAdditionalTravelataTours = (tourProductsGroup: Backbone.Model[], cheapestToursIdentities: string[]): Backbone.Model[] => {
    const filteredTravelataTours = tourProductsGroup.filter((tourProduct) => {
        const operator = tourProduct.get('tour')?.get('operator') as Operator;
        return operators.MY_AGENT.includes(operator?.id);
    });
    const cheapestTravelataTour = filteredTravelataTours.find((t) => cheapestToursIdentities.includes(t.get('id')))
    const sortedTravelataTours =  _.sortBy(filteredTravelataTours, (tour) => tour.get('finalPrice'));
    const tourRegular = sortedTravelataTours.find((tour) => tour.get('transferType') === 'none' && !tour.get('tour').get('block'));
    const tourRegularTransfer = sortedTravelataTours.find((tour) => tour.get('transferType') !== 'none' && !tour.get('tour').get('block'));
    const tourBlock = sortedTravelataTours.find((tour) => tour.get('transferType') === 'none' && tour.get('tour').get('block'));
    const tourBlockTransfer = sortedTravelataTours.find((tour) => tour.get('transferType') !== 'none' && tour.get('tour').get('block'));
    const res = [tourRegular, tourRegularTransfer, tourBlock, tourBlockTransfer].filter((t) => !!t && t.get('id') !== cheapestTravelataTour?.get('id')) as Backbone.Model[];
    return res;
   
};

export { prepareTourProductsWithoutHotelAndRailway, prepareTourIdentities, getCheapestTravelataTourWithTransfer, getAdditionalTravelataTours };
